import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateSimulatorApplicationDialog } from "components/TrainingContent/SimulatorApplication/CreateSimulatorApplicationDialog"
import { SimulatorApplicationList } from "components/TrainingContent/SimulatorApplication/SimulatorApplicationList"

export function Simulators() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>SIMULATORS</Title>
            </Grid>
            <Grid item>
              <CreateSimulatorApplicationDialog />
            </Grid>
          </Grid>
          <SimulatorApplicationList />
        </Paper>
      </Grid>
    </Grid>
  )
}
